<script setup>
import { Checkmark16, Subtract16 } from '@carbon/icons-vue';
import { Checkbox as PolarisCheckbox } from 'next/polaris/ui/checkbox';

defineProps({
  indeterminate: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['change']);

const modelValue = defineModel('modelValue', {
  type: Boolean,
  default: false,
});

// The kit's checkbox is reka-ui's: it reports `true | false` (never
// 'indeterminate' after a click — clicking an indeterminate checkbox moves it
// to checked). The woot contract stays: update:modelValue with the boolean,
// and `change` with the same shape callers already read (`event.target.checked`).
const handleKitChange = value => {
  const checked = value === true;
  modelValue.value = checked;
  emit('change', { target: { checked } });
};
</script>

<template>
  <PolarisCheckbox
    v-slot="{ state }"
    :model-value="indeterminate ? 'indeterminate' : modelValue"
    :disabled="disabled"
    @update:model-value="handleKitChange"
  >
    <Subtract16 v-if="state === 'indeterminate'" class="size-3.5" />
    <Checkmark16 v-else class="size-3.5" />
  </PolarisCheckbox>
</template>
